import SLAListPage from "./SLA";

const SLAConfigurationPage = () => {
  return (
    <div className="p-6">
      <SLAListPage />
    </div>
  );
};

export default SLAConfigurationPage;
